import React from 'react';
import UseCollectionWorkProjectRecord from '../../hooks/apis/useCollectionWorkProjectRecord';
import UseCollectionWorkProject from '../../hooks/apis/useCollectionWorkProject';
import {Button, message, Popover, Space} from 'antd';
import QuickRouter from '../../utils/QuickRouter';
import UseUser, {UserCategory, UserGender, UserGrade, UserType} from '../../hooks/apis/useUser';
import XLSX from 'xlsx';
export default function CollectionWorkExportReport(props: {collectionWorkId: number}) {
  const listRecord = UseCollectionWorkProjectRecord.list();
  const listScore = UseCollectionWorkProject.listScore();
  const listUser = UseUser.list();
  const loading = listRecord.loading || listScore.loading || listUser.loading;
  async function exportData(isTime: boolean) {
    try {
      const recordList = await listRecord.request({collectionWorkId: props.collectionWorkId});
      const scoreList = await listScore.request({wordId: props.collectionWorkId});
      const userList = await listUser.request();
      const reviewerList = userList.filter(i => i.type === UserType.评审员).sort((a, b) => a.id - b.id);
      const titles = ['序号', '用户 ID', '姓名', '性别', '出生日期', '组别', '学校', '年级', '班级', '指导老师', '联系电话', '备注', '项目名称', '作品名称'];
      if (isTime) {
        reviewerList.forEach(reviewer => {
          titles.push(reviewer.legalName + '点击时间');
          titles.push(reviewer.legalName + '评分时间');
        });
      } else {
        reviewerList.forEach(reviewer => titles.push(reviewer.legalName + '分值'));
        titles.push('已评分平均', '所有评审平均分');
      }

      const datas: any[][] = [];
      datas.push(titles);
      recordList.map(record => {
        const data: any[] = [
          record.id,
          record.user?.id,
          record.user?.legalName,
          record.user?.gender ? UserGender[record.user.gender] : '未填写',
          record.user?.birthDate,
          record.user?.category ? UserCategory[record.user.category] : '未填写',
          record.user?.schoolName,
          record.user?.grade ? UserGrade[record.user.grade] : '未填写',
          record.user?.classNo,
          record.user?.coachName,
          record.user?.telephone,
          record.user?.remark,
          record.collectionWorkProject?.name,
          record.name,
        ];
        if (isTime) {
          reviewerList.forEach(reviewer => {
            const existScore = scoreList.find(s => s.userId === reviewer.id && s.collectionWorkProjectRecordId === record.id);
            if (existScore && existScore.downloadTime) {
              data.push(existScore.downloadTime);
            } else {
              data.push('未点击');
            }
            if (existScore && existScore.reviewTime) {
              data.push(existScore.reviewTime);
            } else {
              data.push('未评分');
            }
          });
        } else {
          let score = 0;
          let reviewCount = 0;
          reviewerList.forEach(reviewer => {
            const existScore = scoreList.find(s => s.userId === reviewer.id && s.collectionWorkProjectRecordId === record.id);
            if (existScore && existScore.reviewTime) {
              score += existScore.score;
              reviewCount++;
              data.push(existScore.score);
            } else {
              data.push('未评分');
            }
          });
          data.push(score / reviewCount);
          data.push(score / reviewerList.length);
        }
        datas.push(data);
      });
      const ws = XLSX.utils.aoa_to_sheet(datas);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '数据'); // 工作簿名称
      XLSX.writeFile(wb, '信息统计.xlsx'); // 保存的文件名
    } catch (e) {
      message.error(e.message);
    }
  }
  return (
    <Popover
      content={
        <Space>
          <Button loading={loading} onClick={() => exportData(false)}>
            项目统计
          </Button>
          <Button loading={loading} onClick={() => exportData(true)}>
            工作统计
          </Button>
        </Space>
      }>
      <a>导出统计</a>
    </Popover>
  );
}
